import { render, staticRenderFns } from "./goodsTable.vue?vue&type=template&id=6b9ebaf0&scoped=true"
import script from "./goodsTable.vue?vue&type=script&lang=js"
export * from "./goodsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9ebaf0",
  null
  
)

export default component.exports